import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { getSubscription } from './autoTopupActions'
import { AutoTopupSubscription } from './autoTopupTypes'

export interface AutoTopupState {
  subscriptions: AutoTopupSubscription[]
  subscriptionLoading: boolean
  subscriptionError: unknown | null
}

const initialState: AutoTopupState = {
  subscriptions: [],
  subscriptionLoading: false,
  subscriptionError: null,
}

const autoTopupSlice = createSlice({
  name: 'autoTopup',
  initialState,
  reducers: {
    getSubscriptionSuccess(
      state,
      action: PayloadAction<AutoTopupSubscription[]>
    ) {
      state.subscriptions = action.payload
      state.subscriptionLoading = false
      state.subscriptionError = null
    },
    getSubscriptionFailed(state, action: PayloadAction<unknown>) {
      state.subscriptionLoading = false
      state.subscriptionError = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getSubscription, (state) => {
      state.subscriptionLoading = true
      state.subscriptionError = null
    })
  },
})

export const autoTopupActions = {
  ...autoTopupSlice.actions,
  getSubscription,
}

export const autoTopupReducer = autoTopupSlice.reducer
